export default "__VITE_ASSET__762a47fc__"